module.exports = __webpack_public_path__ + "img/curtain_up_50.087bd682.svg";